var media_desktop   = 1024,
    media_laptop    = 900,
    media_tablet    = 768,
    media_mobile    = 320;

$(window).on('load',function(){
    
    if($(window).width() <= media_desktop){
        
        if($(window).width() < media_laptop){
            
            if($(window).width() < media_tablet){
                
                if(!$('html').hasClass('mobile')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('tablet');
                    $('html').addClass('mobile');
                }
            }
            else{
                
                if(!$('html').hasClass('tablet')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('mobile');
                    $('html').addClass('tablet');
                }
            }
            
        }
        else{
            
            if(!$('html').hasClass('laptop')){
                $('html').removeClass('desktop').removeClass('tablet').removeClass('mobile');
                $('html').addClass('laptop');
            }
        }
    }
    else{
        
        if(!$('html').hasClass('desktop')){
            $('html').removeClass('laptop').removeClass('tablet').removeClass('mobile');
            $('html').addClass('desktop');
        }
    }
    
    init_slide();
});

$(window).resize(function(){
    
    if($(window).width() <= media_desktop){
        
        if($(window).width() < media_laptop){
            
            if($(window).width() < media_tablet){
                
                if(!$('html').hasClass('mobile')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('tablet');
                    $('html').addClass('mobile');
                    
                    startSlide();
                }
            }
            else{
                
                if(!$('html').hasClass('tablet')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('mobile');
                    $('html').addClass('tablet');
                    
                    startSlide();
                }
            }
            
        }
        else{
            
            if(!$('html').hasClass('laptop')){
                $('html').removeClass('desktop').removeClass('tablet').removeClass('mobile');
                $('html').addClass('laptop');
                    
                    startSlide();
            }
        }
    }
    else{
        
        if(!$('html').hasClass('desktop')){
            $('html').removeClass('laptop').removeClass('tablet').removeClass('mobile');
            $('html').addClass('desktop');
                    
                    startSlide();
        }
    }
});

function init_slide(){
    
    slider = [];
    
    $('[data-slide]').each(function(){
        var o = "",
            e = jQuery(this),
            i = 0;

        if($('html').hasClass('desktop')){
            o = $(this).data('slide').desktop;
        }else{
            if($('html').hasClass('laptop')){
                o = $(this).data('slide').laptop;
            }else{
                if($('html').hasClass('tablet')){
                    o = $(this).data('slide').tablet;
                }else{
                    o = $(this).data('slide').mobile;
                }
            }
        }
        
        var minItems = parseInt(defaultValue('1',o.minItems));
        
        if(minItems < $('> *', e).length){
            var settings = {
                    mode                : defaultValue('horizontal',o.mode).toString(),
                    speed               : parseInt(defaultValue('500',o.speed)),
                    pause               : parseInt(defaultValue('4000',o.speed)),
                    slideMargin         : parseInt(defaultValue('0',o.slideMargin)),
                    startSlide          : parseInt(defaultValue('0',o.startSlide)),
                    randomStart         : JSON.parse(defaultValue('false',o.randomStart)),
                    infiniteLoop        : JSON.parse(defaultValue('true',o.infiniteLoop)),
                    hideControlOnEnd    : JSON.parse(defaultValue('false',o.hideControlOnEnd)),
                    adaptiveHeight      : JSON.parse(defaultValue('false',o.adaptiveHeight)),
                    adaptiveHeightSpeed : parseInt(defaultValue('500',o.adaptiveHeightSpeed)),
                    responsive          : JSON.parse(defaultValue('true',o.responsive)),
                    touchEnabled        : JSON.parse(defaultValue('true',o.touchEnabled)),
                    swipeThreshold      : parseInt(defaultValue('50',o.swipeThreshold)),
                    pager               : JSON.parse(defaultValue('true',o.pager)),
                    pagerType           : defaultValue('full',o.pagerType).toString(),
                    pagerShortSeparator : defaultValue('/',o.pagerShortSeparator).toString(),
                    controls            : JSON.parse(defaultValue('true',o.controls)),
                    nextText            : defaultValue('Next',o.nextText).toString(),
                    prevText            : defaultValue('Prev',o.prevText).toString(),
                    autoControls        : JSON.parse(defaultValue('false',o.autoControls)),
                    startText           : defaultValue('Start',o.startText).toString(),
                    stopText            : defaultValue('Stop',o.stopText).toString(),
                    autoControlsCombine : JSON.parse(defaultValue('false',o.autoControlsCombine)),
                    auto                : JSON.parse(defaultValue('false',o.auto)),
                    stopAutoOnClick     : JSON.parse(defaultValue('false',o.stopAutoOnClick)),
                    autoDirection       : defaultValue('next',o.autoDirection).toString(),
                    autoHover           : JSON.parse(defaultValue('false',o.autoHover)),
                    autoDelay           : parseInt(defaultValue('0',o.autoDelay)),
                    minSlides           : parseInt(defaultValue('1',o.minSlides)),
                    maxSlides           : parseInt(defaultValue('1',o.maxSlides)),
                    moveSlides          : parseInt(defaultValue('0',o.moveSlides)),
                    slideWidth          : parseInt(defaultValue('0',o.slideWidth)),
                    shrinkItems         : JSON.parse(defaultValue('false',o.shrinkItems)),
                    keyboardEnabled     : JSON.parse(defaultValue('false',o.keyboardEnabled)),
                    ariaLive            : JSON.parse(defaultValue('true',o.ariaLive)),
                    ariaHidden          : JSON.parse(defaultValue('true',o.ariaHidden)),
                    onSliderLoad        : function(){
                        jQuery('> *:not(.bx-clone):eq('+parseInt(defaultValue('0',o.startSlide))+')',e).addClass('active');
                        
                        if(e.closest('.mdl-hero_home').length)
                            e.closest('.mdl-hero_home').each(function(){
                                var parint = $(this);
                                counti = 0,
                                maxitem = $('.m-page_item',parint).length;

                                interi = setInterval(function(){
                                    counti < (maxitem - 1) ?
                                        counti++:
                                        counti = 0;
                                        
                                    $('.bx-pager-item:eq(' + counti % maxitem + ') a',parint).click();
                                },10000);
                                
                                $('.m-page_item:eq(0)',parint).addClass('animation');

                                $('.m-page_item',parint).on('click',function(){
                                    var indi = $(this).index();

                                    $('.bx-pager-item:eq(' + indi + ') a',parint).click();
                                    
                                });
                                
                                $('[data-slidepager]').on('click',function(){
                                    var indi = $(this).data('slidepager');
                                    
                                    $('.bx-pager-item:eq(' + indi + ') a',parint).click();
                                });
                                
                            });
                    },
                    onSlideBefore: function(currentSlideNumber,oldIndex,newIndex){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                        jQuery('> *',e).addClass('eff_slide');
                        setTimeout(function(){
                            jQuery('> *',e).removeClass('eff_slide');
                        },300);
                        
                        if(!e.closest('.j-sharedAux').length)
                            if($('.js-sliderShared').length){
                                var sliderShared = e.closest('.js-sliderShared');
                                $('.j-sharedAux .bx-prev',sliderShared).click();
                            }
                        
                        if(e.closest('.mdl-hero_home').length)
                            e.closest('.mdl-hero_home').each(function(){
                                var parint = $(this);

                                $('.m-page_item',parint).removeClass('animation').removeClass('active');
                                $('.m-page_item:eq(' + newIndex + ')',parint).addClass('animation').addClass('active');
                                
                                clearInterval(interi);
                                counti = newIndex;
                                interi = setInterval(function(){
                                    counti < (maxitem - 1) ?
                                        counti++:
                                        counti = 0;
                                    $('.bx-pager-item:eq(' + counti % maxitem + ') a',parint).click();
                                },10000);
                            });
                    },
                    onSlideAfter: function(currentSlideNumber){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                        jQuery('> *',e).addClass('eff_slide');
                        setTimeout(function(){
                            jQuery('> *',e).removeClass('eff_slide');
                        },300);
                        
                        if(!e.closest('.j-sharedAux').length)
                            if($('.js-sliderShared').length){
                                var sliderShared = e.closest('.js-sliderShared');
                                $('.j-sharedAux .bx-next',sliderShared).click();
                            }
                    }
            };
        
            slider.push($(this).bxSlider(settings));
        }
        
    });
}

function startSlide(){
    
    var i = 0;
    
    $('[data-slide]').each(function(){
        var o = "",
            e = jQuery(this);
        
        if($('html').hasClass('desktop')){
            o = $(this).data('slide').desktop;
        }else{
            if($('html').hasClass('laptop')){
                o = $(this).data('slide').laptop;
            }else{
                if($('html').hasClass('tablet')){
                    o = $(this).data('slide').tablet;
                }else{
                    o = $(this).data('slide').mobile;
                }
            }
        }
        
        var minItems = parseInt(defaultValue('1',o.minItems));
        
        if(minItems < $('> *', e).length){
            var settings = {
                    mode                : defaultValue('horizontal',o.mode).toString(),
                    speed               : parseInt(defaultValue('500',o.speed)),
                    pause               : parseInt(defaultValue('4000',o.speed)),
                    slideMargin         : parseInt(defaultValue('0',o.slideMargin)),
                    startSlide          : parseInt(defaultValue('0',o.startSlide)),
                    randomStart         : JSON.parse(defaultValue('false',o.randomStart)),
                    infiniteLoop        : JSON.parse(defaultValue('true',o.infiniteLoop)),
                    hideControlOnEnd    : JSON.parse(defaultValue('false',o.hideControlOnEnd)),
                    adaptiveHeight      : JSON.parse(defaultValue('false',o.adaptiveHeight)),
                    adaptiveHeightSpeed : parseInt(defaultValue('500',o.adaptiveHeightSpeed)),
                    responsive          : JSON.parse(defaultValue('true',o.responsive)),
                    touchEnabled        : JSON.parse(defaultValue('true',o.touchEnabled)),
                    swipeThreshold      : parseInt(defaultValue('50',o.swipeThreshold)),
                    pager               : JSON.parse(defaultValue('true',o.pager)),
                    pagerType           : defaultValue('full',o.pagerType).toString(),
                    pagerShortSeparator : defaultValue('/',o.pagerShortSeparator).toString(),
                    controls            : JSON.parse(defaultValue('true',o.controls)),
                    nextText            : defaultValue('Next',o.nextText).toString(),
                    prevText            : defaultValue('Prev',o.prevText).toString(),
                    autoControls        : JSON.parse(defaultValue('false',o.autoControls)),
                    startText           : defaultValue('Start',o.startText).toString(),
                    stopText            : defaultValue('Stop',o.stopText).toString(),
                    autoControlsCombine : JSON.parse(defaultValue('false',o.autoControlsCombine)),
                    auto                : JSON.parse(defaultValue('false',o.auto)),
                    stopAutoOnClick     : JSON.parse(defaultValue('false',o.stopAutoOnClick)),
                    autoDirection       : defaultValue('next',o.autoDirection).toString(),
                    autoHover           : JSON.parse(defaultValue('false',o.autoHover)),
                    autoDelay           : parseInt(defaultValue('0',o.autoDelay)),
                    minSlides           : parseInt(defaultValue('1',o.minSlides)),
                    maxSlides           : parseInt(defaultValue('1',o.maxSlides)),
                    moveSlides          : parseInt(defaultValue('0',o.moveSlides)),
                    slideWidth          : parseInt(defaultValue('0',o.slideWidth)),
                    shrinkItems         : JSON.parse(defaultValue('false',o.shrinkItems)),
                    keyboardEnabled     : JSON.parse(defaultValue('false',o.keyboardEnabled)),
                    ariaLive            : JSON.parse(defaultValue('true',o.ariaLive)),
                    ariaHidden          : JSON.parse(defaultValue('true',o.ariaHidden)),
                    onSliderLoad        : function(){
                        jQuery('> *:not(.bx-clone):eq('+parseInt(defaultValue('0',o.startSlide))+')',e).addClass('active');
                    },
                    onSlideBefore: function(currentSlideNumber){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                        jQuery('> *',e).addClass('eff_slide');
                        setTimeout(function(){
                            jQuery('> *',e).removeClass('eff_slide');
                        },300);
                        
                        if(!e.closest('.j-sharedAux').length)
                            if($('.js-sliderShared').length){
                                var sliderShared = e.closest('.js-sliderShared');
                                $('.j-sharedAux .bx-prev',sliderShared).click();
                            }
                    },
                    onSlideAfter: function(currentSlideNumber){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                        jQuery('> *',e).addClass('eff_slide');
                        setTimeout(function(){
                            jQuery('> *',e).removeClass('eff_slide');
                        },300);
                        
                        if(!e.closest('.j-sharedAux').length)
                            if($('.js-sliderShared').length){
                                var sliderShared = e.closest('.js-sliderShared');
                                $('.j-sharedAux .bx-next',sliderShared).click();
                            }
                    }
            };

            slider[i].reloadSlider(settings);

            i++;
        }
        
    });
}

// GLOBAL

function defaultValue(def,value){
    
    typeof value === "undefined" ?
        val = def:
        val = value;
    
    return val;
}

$(window).on('load',function(){
    
    if($('.sta-masonry').length)
        $('.sta-masonry').each(function(){
        $(this).masonry();
    });
    
    //[Selector personalizado form]
    if($('.sta-g-select').length)
        $('.sta-g-select').each(function(){
            var o = $(this);
            $('.sta-g_s_view', o).text($('select option:selected', o).text());
            
            $('select', o).change(function(){
                $('.sta-g_s_view', o).text($('select option:selected', o).text());
                if(!$('.sta-g_s_view', o).hasClass('active')){
                    o.addClass('active');
                }
            });
        });
    
    //[Scroll Menu]
    if($('[class^="mdl-header"]').length)
        if($(window).scrollTop() > 0){
            $('[class^="mdl-header"]').addClass('scroller');
            $('[class^="mdl-form"]').addClass('scroller');
        }
        else{
            $('[class^="mdl-header"]').removeClass('scroller');
            $('[class^="mdl-form"]').removeClass('scroller');
        }
    
    //[Scroll Booking]
    if($('[class^="mdl-header"]').length && $('.sta-triggerform').length)
        if($(window).scrollTop() > $('.sta-triggerform').offset().top){
            $('[class^="mdl-header"]').addClass('scrollerbooking');
            $('[class^="mdl-form"]').addClass('scrollerbooking');
        }
        else{
            $('[class^="mdl-header"]').removeClass('scrollerbooking');
            $('[class^="mdl-form"]').removeClass('scrollerbooking');
        }
    
    if(jQuery('.sta-selector').length){
        $('.sta-selector').each(function(){
            var o = $(this);
            type = $('.s-list_selector [class^="sta-"]', o).attr('class');

            $('.s-list_selector [class^="sta-"]', o).click(function(){
                type = $(this).attr('class');

                $('.s-items > *', o).removeClass('selected');
                $('.s-items .'+type+'', o).addClass('selected');
                $('.s-items > *', o).removeClass('show');
                $('.s-c_trigger', o).hide();
                $('.s-list_selector [class^="sta-"]', o).removeClass('selected');
                $(this).addClass('selected');
                $('select', o).val(type);
                $('.sta-g_s_view', o).text($('select option:selected', o).text());
                
                if(jQuery('[defaultMasonry]').length)defaultMasonry();
            });

            $('select', o).change(function(){
                value = $('select option:selected', o).val();

                $('.s-list_selector .'+value+'', o).click();
            });
        });
        $('.s-list_selector [class^="sta-"]:eq(0)').click();
    }
    
    if(jQuery('[defaultMasonry]').length)defaultMasonry();
    
    if(jQuery('.js-switch').length)
        $('.js-switch').each(function(){
            var o = $(this);
            
            o.click(function(){
                $('body').toggleClass('switchDark');
            });
        });
})
.on('scroll',function(){
    
    //[Scroll Menu]
    if($('[class^="mdl-header"]').length)
        if($(window).scrollTop() > 0){
            $('[class^="mdl-header"]').addClass('scroller');
            $('[class^="mdl-form"]').addClass('scroller');
        }
        else{
            $('[class^="mdl-header"]').removeClass('scroller');
            $('[class^="mdl-form"]').removeClass('scroller');
        }
    
    //[Scroll Booking]
    if($('[class^="mdl-header"]').length && $('.sta-triggerform').length)
        if($(window).scrollTop() > $('.sta-triggerform').offset().top){
            $('[class^="mdl-header"]').addClass('scrollerbooking');
            $('[class^="mdl-form"]').addClass('scrollerbooking');
        }
        else{
            $('[class^="mdl-header"]').removeClass('scrollerbooking');
            $('[class^="mdl-form"]').removeClass('scrollerbooking');
        }
});


//Efectos de carga y scroll
$(window).on('load', function(){
    
    $('.eff-init_trans').each(function(){
        $(this).removeClass('eff-init_trans');
    });
    
    $('.eff-noactive').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true) * 1.2)){
            o.addClass('eff-active');
            
            setTimeout(function(){
                o.removeClass('eff-noactive');
                o.removeClass('eff-active');
            },1000);
        }
    });
    
    $('.eff-noactiveimg').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-activeimg');
            
            setTimeout(function(){
                o.removeClass('eff-noactiveimg');
                o.removeClass('eff-activeimg');
            },1000);
        }
    });
    
    $('.eff-noactivehero').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-activehero');
            
            setTimeout(function(){
                o.removeClass('eff-noactivehero');
                o.removeClass('eff-activehero');
            },2000);
        }
    });
})
.scroll(function(){
    
    $('.eff-noactive').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-active');
            
            setTimeout(function(){
                o.removeClass('eff-noactive');
                o.removeClass('eff-active');
            },1000);
        }
    });
    
    $('.eff-noactiveimg').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-activeimg');
            
            setTimeout(function(){
                o.removeClass('eff-noactiveimg');
                o.removeClass('eff-activeimg');
            },1000);
        }
    });
    
    $('.eff-noactivehero').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-activehero');
            
            setTimeout(function(){
                o.removeClass('eff-noactivehero');
                o.removeClass('eff-activehero');
            },2000);
        }
    });
});


// SEE MORE
$(window).on('load', function(){

    if($('.sta-see_more').length)
        setViewMore();
    
    if($('.sta-countdown').length)
        $('.sta-countdown').countdown($('.sta-countdown input').val(), function(event) {
            $('.s-day',this).text(event.strftime('%D'));
            $('.s-hour',this).text(event.strftime('%H'));
            $('.s-min',this).text(event.strftime('%M'));
            $('.s-sec',this).text(event.strftime('%S'));
        });
});
function seeMore(){
    jQuery('.sta-see_more').each(function(){
        var o = jQuery(this),
            h = jQuery('[s_see_more-data]',o).attr('s_see_more-data').split(','),
            get_height = 0;

        var altura = jQuery('.s_see_more-content',o).data('altura');
        
        
        function seeMore_getHeight(){

            if(jQuery(window).width() > 1024){
                get_height = h[0] * altura;
            }
            else{
                if(jQuery(window).width() <= 1024){
                    get_height = h[1] * altura;

                    if(jQuery(window).width() <= 768){
                        get_height = h[2] * altura;

                        if(jQuery(window).width() < 768){
                            get_height = h[3] * altura;
                        }
                    }
                }
            }
        }
        
        seeMore_getHeight();
        if (get_height != '') {
            if(jQuery('.s_see_more-content',o).is(':visible') && jQuery('.s_see_more-content',o).height() > get_height){

                jQuery('.s_see_more-content',o).attr('s_see_more-height', (jQuery('.s_see_more-content',o).height()));

                jQuery('.s_see_more-content',o).css('height', get_height + 'px');
                jQuery('.s_see_more-trigger',o).unbind('click').click(function(){

                    jQuery('.s_see_more-trigger',o).hasClass('open') ?
                        SM_closeSlider():
                        SM_openSlider();
                });

                jQuery('.s_see_more-trigger',o).show().css({opacity: '1', cursor: 'pointer'});
            }
            
            if(jQuery('.s_see_more-content',o).data('notequal') != 'S' && jQuery('.s_see_more-content',o).is(':visible') && jQuery('.s_see_more-content',o).height() <= get_height){


                jQuery('.s_see_more-content',o).css('height', get_height + 'px');
                
            }
        } else {
            jQuery('.s_see_more-trigger',o).hide();
        }

        function SM_openSlider(){
            var open_height = jQuery('.s_see_more-content',o).attr('s_see_more-height') + 'px';

            jQuery('.s_see_more-content',o).animate({'height': open_height}, {duration: 'fast' });
            jQuery('.s_see_more-trigger',o).addClass('open');
        }

        function SM_closeSlider(){
            jQuery('.s_see_more-content',o).animate({'height': get_height + 'px'}, {duration: 'fast' });
            jQuery('.s_see_more-trigger',o).removeClass('open');
        }
    });
}

function setViewMore() {
    $('*[s_see_more-data]').each(function() {
        // Calcula el line height
        var altura = $(this).height();
		var s = $(this).html();
		$(this).html('A');
		var lineHeight = $(this).height();
		$(this).html(s);
		var lines = altura / lineHeight;
		$(this).attr('data-lines', lines);
        $(this).attr('data-altura', altura / lines);
        $(this).siblings().html('<a class="s_see_more-trigger m-more" href="javascript:"><span>###MAS###</span><span>###MENOS###</span></a>');        
        $(this).addClass('s_see_more-content');
        var html = $(this).parent().html();
        $(this).parent().html('<div class="sta-see_more">'+html+'</div>');
        
        seeMore();
    });
}


//Efecto parallax
$(window).on('load', function(){
    
    if($('.js-parallax').length)
        $('.js-parallax').each(function(){
            
            var o = $(this),
                init_transY = 40,
                ended_transY = -40,
                diff_transY = init_transY - ended_transY;

            $(window).scroll(function(){

                var bot_trig = $(window).scrollTop() + $(window).height(),
                    top_trig = $(window).scrollTop(),
                    bot_elem = o.offset().top,
                    top_elem = o.offset().top + o.height();


                if(bot_trig >= bot_elem && top_trig <= top_elem){

                    var s0 = o.height() + $(window).height(),
                        s1 = o.offset().top - $(window).height(),
                        s2 = s1 - $(window).scrollTop(),
                        s3 = s0 - s0 + s2,
                        s4 = s3 / s0,
                        pos_parallax = diff_transY * s4,
                        value = init_transY + pos_parallax;

                    o.css({"transform" : 'translateY(' + value + 'px)'})
                }
            });
        });
});
function defaultMasonry(){
    jQuery('[defaultMasonry]').each(function(){
        jQuery(this).masonry();
    });
}

//Target
$(document).ready(function(){
    
    //[Anclas con animación - Global]
    $('a[href*="#"]:not([href="#"])').click(function(){
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

            if (target.length) {
                $('html, body').animate({
                    scrollTop: (target.offset().top - 170)
                }, 1000);

                return false;
            }
        }
    });
});

/* Unselector */
$(function(){
    
    if($('.s-unselectorclick').length)
        $('.s-unselectorclick').each(function(){
            var o = $(this),
                go = o.data('unselectorGo'),
                id = o.parent().data('unselectorId'),
                module = o.closest('[class^="mdl-"]');

            o.click(function(){

                o.hasClass('selected') ?
                    $('[data-unselector-id="'+ id +'"] > [data-unselector-item="'+ go +'"]',module).show():
                    $('[data-unselector-id="'+ id +'"] > [data-unselector-item="'+ go +'"]',module).hide();

                o.toggleClass('selected');

                if($('.sta-masonry',module).length)
                    $('.sta-masonry',module).each(function(){
                        $(this).masonry();
                    });
            });
        });
});

/* Show video */
$(function(){
    
    if($('.js-videoShow').length)
        $('.js-videoShow').each(function(){
            var o = $(this);

            $('.j-videoShow__trigger',o).on('click', function(){
                $('.j-videoShow__trigger',o).fadeOut();
            });
        });
});

$(function(){
    
    if($('.js-check').length)
        $('.js-check').each(function(){
            var o = $(this);

            $('input',o).on('click', function(){
                o.toggleClass('active');
            });
        });
});

/* tabs */
$(function(){
    
    if($('.js-tabclick').length)
        $('.s-tabclick').each(function(){
            var o = $(this),
                go = o.data('tabsGo'),
                id = o.parent().data('tabsId');

            o.click(function(){
                $('[data-tabs-id="'+ id +'"] > [data-tabs-go]').removeClass('selected');
                o.addClass('selected');

                $('[data-tabs-id="'+ id +'"] > [data-tabs]').removeClass('selected');
                $('[data-tabs-id="'+ id +'"] > [data-tabs="'+ go +'"]').addClass('selected');
            });
        });
    
    if($('.js-tabclick').length)
        $('.s-tabclickselect').each(function(){
            var o = $(this),
                id = o.data('tabsId');
            
            
            o.change(function(){
                var go = $('option:selected', o).data('tabsGo');

                $('[data-tabs-id="'+ id +'"] > [data-tabs-go]').removeClass('selected');
                o.addClass('selected');

                $('[data-tabs-id="'+ id +'"] > [data-tabs]').removeClass('selected');
                $('[data-tabs-id="'+ id +'"] > [data-tabs="'+ go +'"]').addClass('selected');
            });
        });
});

/*Magnific popup*/
$(function(){
   
    if($('.sta-defaultModal').length)defaultModal();
});

function defaultModal(){
    jQuery('.sta-defaultModal').each(function(){
        var o = jQuery(this).attr('href').replace('#', '');
        
        jQuery('.sta-defaultModal').magnificPopup({
            type: 'inline',
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in'
        });

        jQuery('#' + o + ' .s_modal-close').click(function(){
            jQuery.magnificPopup.close();
        });
    });
}

/*Accordion*/
$(function(){
    
    if($('.js-accordion').length)defaultAccordion();
});

function defaultAccordion(){
    $('.js-accordion').each(function(){
        var o = $(this);
        
        $('.js-header',o).first().click(function(){
            
            $('.js-section',o).first().slideToggle();
            o.toggleClass('open');
        });
    });
}

/*Form element active*/
$(document).on('keypress change', 'input', function() {
    
   $(this).val().length != 0 ?
      $(this).parent().addClass('active'):
      $(this).parent().removeClass('active');
});

/*Dropdown*/
$(function() {
  
  $('.m-dropdown > .m-caption').on('click', function() {
    $(this).parent().toggleClass('open');
  });
  
  $('.m-dropdown > .m-list > .m-itemoption').on('click', function() {
    $('.m-dropdown > .m-list > .m-itemoption').removeClass('selected');
    $(this).addClass('selected').parent().parent().removeClass('open').children('.m-caption').text( $(this).text() );
  });
  
  $(document).on('keyup', function(evt) {
    if ( (evt.keyCode || evt.which) === 27 ) {
      $('.m-dropdown').removeClass('open');
    }
  });
  
  $(document).on('click', function(evt) {
    if ( $(evt.target).closest(".m-dropdown > .m-caption").length === 0 ) {
      $('.m-dropdown').removeClass('open');
    }
  });
  
});

/*Pager*/
$(function(){
    
    $('.js-pager').each(function(){
        var o = $(this),
            i = '0' + $('[data-slide] > *',o).length;
        
        $('.j-current',o).text('01');
        $('.j-total',o).text(i.slice(-2));
    });
});

/*Custome prev/next button*/
$(function(){
    
    $('.js-prev').on('click', function(){
        var o = $(this),
            parent = o.closest('.bx-wrapper');
        
        $('.bx-prev',parent).click();
    });
    
    $('.js-next').on('click', function(){
        var o = $(this),
            parent = o.closest('.bx-wrapper');
        
        $('.bx-next',parent).click();
    });
});

$(window).on('load', function(){
    
    $('.js-pager').each(function(){
        var o = $(this);
    
        $('.bx-controls-direction',o).on('click', function(){
            var text = $('.bx-pager',o).text(),
                text = text.split('|'),
                current = '0' + text[0];

            o.each(function(){
                var o = $(this);

                $('.j-current',o).text(current.slice(-2));
            });
        });
    });
});

/*Tabs*/
$(function(){
    
    $('.s-tabclick').each(function(){
        var o = $(this),
            go = o.data('tabsGo'),
            id = o.parent().data('tabsId');
        
        o.click(function(){
            $('[data-tabs-id="'+ id +'"] > [data-tabs-go]').removeClass('selected');
            o.addClass('selected');
            
            $('[data-tabs-id="'+ id +'"] > [data-tabs]').removeClass('selected');
            $('[data-tabs-id="'+ id +'"] > [data-tabs="'+ go +'"]').addClass('selected');
        });
    });
});

/*Switchers*/
$(function(){
    
    $('.js-controls').each(function(){
        var o = $(this);
        
        $('.j-controls__content > *',o).on('click', function(){
            o.toggleClass('j-controls__switched');
        });
    });
});

/*Splittings header words*/
$(function(){
    
    $('.eff-splittingswords').each(function(){
        var o = $(this);
        
        const results = Splitting({ target: o, whitespace: true, by: 'words' });
    });
});

/**/
$(function(){
    
    if($('.js-pager_click').length)
        $('.js-pager_click').each(function(){
            var o = $(this),
                i = $('.m-slide:eq(0) > *',o).length;
            
            for(count = 0; count < i; count++)
                $('.js-pager_click_trigger',o).append('<div></div>');
            
            $('.js-pager_click_trigger > *:eq(0)',o).addClass('active');
            
            $('.js-pager_click_trigger > *',o).on('click', function(){
                var index = $(this).index();
                
                $('.bx-wrapper',o).each(function(){
                    var e = $(this);
                    
                    $('.bx-pager .bx-pager-item:eq('+index+') a',e).click();
                });
                
                $(this).siblings().removeClass('active');
                $(this).addClass('active');
            });
        });
});

/*Custome prev/next button all panel slide*/
$(window).on('load', function(){
    
    if($('.js-control_clickall').length){
        $('.js-control_clickall').each(function(){

            if($('.bx-controls-direction',this).length){
                $('.js-prevall',this).parent().addClass('active');
            }
        });
    }
    
    $('.js-control_clickall_inherit .bx-prev').on('click', function(){
        var o = $(this),
            parent = o.closest('.js-control_clickall');
        
        $('.js-control_clickall_custom .bx-prev',parent).click();
    });
    
    $('.js-control_clickall_inherit .bx-next').on('click', function(){
        var o = $(this),
            parent = o.closest('.js-control_clickall');
        console.log('despues');
        
        $('.js-control_clickall_custom .bx-next',parent).click();
    });
    
    $('.js-prevall').on('click', function(){
        var o = $(this),
            parent = o.closest('.js-control_clickall');
        
        $('.bx-prev',parent).click();
    });
    
    $('.js-nextall').on('click', function(){
        var o = $(this),
            parent = o.closest('.js-control_clickall');
        
        $('.bx-next',parent).click();
    });
});

/*Overflow hidden page on click*/
$(window).on('load', function(){
    
    if($('#sta-css-menu, #sta-css-booking').length)
        $('#sta-css-menu, #sta-css-booking').click(function(){            
            $('html').toggleClass('over-hidden');
            
            if($('html').hasClass('over-hidden')){
                scroll_o = $(window).scrollTop();
            }
            else{
                $('body').css({'position': 'static'});
                $(window).scrollTop(scroll_o);
            }
        });
});

//Button list
$(function(){
   
    $('body').on('click', '.sta-button_list .s-head', function(){
        var o = $(this).parent('.sta-button_list');
        $(this).toggleClass('open');
        o.toggleClass('open');
        $('.s-list',o).slideToggle();
    });
    
    if($('.sta-inputfile').length)
        $('.sta-inputfile').each(function(){
            var o = $(this);

            $('input[type="file"]', o).on('change', function(){

                if ($(this).val()) {
                    var filename = $(this).val().split("\\");

                    filename = filename[filename.length - 1];
                    $('.s-name',o).text(filename);
                    o.addClass('full');
                }
            });

            $('.s-clear', o).on('click', function() { 
                $('input[type="file"]', o).val(''); 
                o.removeClass('full');
            });
        });
});

//Messages
$(function() {
    $('.m-message .m-close').click(function(){
        $(this).parents(".m-message").remove();
    });
});